import React from "react";

export default function ContactFooterFormCard({
  form,
  values,
  onChange,
  onSubmit,
  isSubmitting,
  isSuccess,
  error,
}) {
  return (
    <div
      className="rounded-[1.6rem] border border-[rgba(255,255,255,0.05)] bg-[rgba(23,24,29,0.92)] p-[1.35rem] shadow-[inset_0_1px_0_rgba(255,255,255,0.02)] sm:p-[1.7rem]"
      id="kontaktformular"
    >
      <h3 className="m-0 text-[clamp(1.55rem,2vw,2rem)] leading-[1.2] text-white">{form.title}</h3>

      <form className="mt-6" onSubmit={onSubmit}>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {form.fields.slice(0, 2).map((field, index) => {
            const key = index === 0 ? "name" : "email";

            return (
              <label key={field.label} className="flex flex-col gap-[0.65rem]">
                <span className="text-[0.7rem] font-bold uppercase tracking-[0.14em] text-[rgba(255,255,255,0.54)]">
                  {field.label}
                </span>
                <input
                  type={field.type}
                  name={key}
                  placeholder={field.placeholder}
                  className="w-full rounded-[1.15rem] border border-[rgba(255,255,255,0.04)] bg-[rgba(255,255,255,0.03)] px-[1.15rem] py-4 text-[rgba(255,255,255,0.9)] outline-none placeholder:text-[rgba(213,219,230,0.28)]"
                  value={values[key]}
                  onChange={onChange}
                  required
                />
              </label>
            );
          })}
        </div>

        <label className="mt-2 flex flex-col gap-[0.65rem]">
          <span className="text-[0.7rem] font-bold uppercase tracking-[0.14em] text-[rgba(255,255,255,0.54)]">
            {form.fields[2].label}
          </span>
          <textarea
            rows="6"
            name="message"
            placeholder={form.fields[2].placeholder}
            className="min-h-[10.75rem] w-full resize-none rounded-[1.15rem] border border-[rgba(255,255,255,0.04)] bg-[rgba(255,255,255,0.03)] px-[1.15rem] py-4 text-[rgba(255,255,255,0.9)] outline-none placeholder:text-[rgba(213,219,230,0.28)]"
            value={values.message}
            onChange={onChange}
            required
          />
        </label>

        {isSuccess ? (
          <p className="mt-1 text-[0.92rem] leading-[1.5] text-[#bdecc8]">{form.successMessage}</p>
        ) : null}
        {error ? <p className="mt-1 text-[0.92rem] leading-[1.5] text-[#ffb4b4]">{error}</p> : null}

        <button
          type="submit"
          className={`mt-[1.35rem] min-h-[3.6rem] w-full rounded-full bg-[#4285f4] font-bold tracking-[-0.01em] text-white shadow-[0_14px_32px_rgba(66,133,244,0.24)] transition duration-200 hover:-translate-y-px hover:bg-[#357ae8] hover:shadow-[0_18px_36px_rgba(66,133,244,0.28)] ${
            isSubmitting ? "cursor-wait opacity-80" : ""
          }`}
          disabled={isSubmitting}
        >
          {isSubmitting ? form.submittingLabel : form.submitLabel}
        </button>
      </form>
    </div>
  );
}
